import(/* webpackMode: "eager", webpackExports: ["BlogCategories"] */ "/codebuild/output/src3826801360/src/octocare-website/components/blog-categories.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogHeader"] */ "/codebuild/output/src3826801360/src/octocare-website/components/blog-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedArticles"] */ "/codebuild/output/src3826801360/src/octocare-website/components/featured-articles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewsletterSection"] */ "/codebuild/output/src3826801360/src/octocare-website/components/newsletter-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src3826801360/src/octocare-website/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src3826801360/src/octocare-website/node_modules/next/dist/client/image-component.js");
